module.exports = __webpack_public_path__ + "static/media/img-03.d012a5e1.jpg";